import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { FirstErrorPipe } from '@fuse/pipes/first-error/first-error.pipe';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { FcTimeInputComponent } from './fc-time-input.component';


@NgModule({
  entryComponents: [
    FcTimeInputComponent
  ],
  declarations: [
    FcTimeInputComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatDatepickerModule,
    NgxMaskModule.forRoot()
  ],
  exports: [
    FcTimeInputComponent
  ],
  providers: [
    FirstErrorPipe
  ]
})
export class FcTimeInputModule { }
